import { render, staticRenderFns } from "./VolumePanel.vue?vue&type=template&id=03c2caee&scoped=true&"
import script from "./VolumePanel.vue?vue&type=script&lang=js&"
export * from "./VolumePanel.vue?vue&type=script&lang=js&"
import style0 from "./VolumePanel.vue?vue&type=style&index=0&id=03c2caee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2caee",
  null
  
)

export default component.exports